/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssessmentWithRelations } from './assessmentWithRelations';


/**
 * (tsType: AssessmentConfigWithRelations, schemaOptions: { includeRelations: true })
 */
export interface AssessmentConfigWithRelations { 
    id?: string;
    configKey: string;
    configValue?: object;
    configType: string;
    createdOn: string;
    modifiedOn: string;
    assessmentId?: string;
    assessment?: AssessmentWithRelations;
}

